
import React from 'react'
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Calendar } from "react-modern-calendar-datepicker";
import { Dialog } from '@material-ui/core';
function CustomDatePicker(props) {
    return <Dialog
        open={props.isOpen}
        onClose={() => props.onClose()}
    >
        <Calendar
            className="ltr-dir"
            onChange={(date) => props.onChange(date.year + '/' + date.month + '/' + date.day)}
            shouldHighlightWeekends
            locale="fa"
        />
    </Dialog>
}
export default CustomDatePicker